const translation = {
  // Navigation
  'nav.home': 'Home',
  'nav.about': 'Over Ons',
  'nav.directory': 'Professionele Gids',
  'nav.knowledge': 'Kenniscentrum',
  'nav.impact': 'Wereldwijde Impact',
  'nav.contact': 'Contact',
  'nav.join': 'Word Lid',

  // Hero Section
  'hero.title': 'Professioneel Ondersteuningsnetwerk voor Integratie in Nederland',
  'hero.subtitle': 'Materiële en morele ondersteuning bieden aan mensen van alle rassen, talen, religies en overtuigingen in elke fase van vluchtelingenkamp tot staatsburgerschap',
  'hero.cta.primary': 'Word Lid van Ons Netwerk',
  'hero.cta.secondary': 'Ontdek Meer',

  // About Section
  'about.title': 'Over Ons',
  'about.subtitle': 'Een Wereldwijde Gemeenschap die Integratie Ondersteunt voor Iedereen die naar Nederland Komt',
  'about.mission.title': 'Onze Missie',
  'about.mission.text': 'Stichting IPN streeft ernaar om uitgebreide materiële en morele ondersteuning te bieden aan mensen van alle rassen, talen, religies en overtuigingen die naar Nederland komen, vanaf hun aankomst in vluchtelingenkampen, tijdens de wachtperiode, het vinden van huisvesting, het verkrijgen van staatsburgerschap en daarna, om succesvolle integratie in de Nederlandse samenleving te waarborgen.',
  'about.vision.title': 'Onze Visie',
  'about.vision.text': 'Een samenleving in Nederland creëren waar iedereen gelijke kansen heeft, culturele diversiteit als rijkdom wordt gezien en integratie succesvol wordt bereikt.',
  'about.values.title': 'Onze Waarden',
  'about.values.text': 'Inclusiviteit, solidariteit, professionaliteit en sociale verantwoordelijkheid zijn de hoekstenen van onze organisatie, weerspiegeld in alles wat we doen.',

  // Core Values
  'values.title': 'Onze Kernwaarden',
  'values.subtitle': 'Principes die Ons Werk Leiden',
  'values.ethics.title': 'Inclusiviteit',
  'values.ethics.text': 'Gelijke ondersteuning en respect voor mensen van alle rassen, talen, religies en overtuigingen',
  'values.wisdom.title': 'Solidariteit',
  'values.wisdom.text': 'Een cultuur van sociale cohesie en wederzijdse hulp',
  'values.service.title': 'Professionele Ondersteuning',
  'values.service.text': 'Integratie-ondersteuning door deskundige begeleiding en praktische oplossingen',
  'values.impact.title': 'Sociale Impact',
  'values.impact.text': 'Blijvende en betekenisvolle verandering creëren in de Nederlandse samenleving',

  // Professional Directory
  'directory.title': 'Professionele Gids',
  'directory.subtitle': 'Maak Contact met Experts die U Kunnen Helpen in Uw Integratieproces',
  'directory.search': 'Zoek professionals...',
  'directory.filter.all': 'Alle Vakgebieden',
  'directory.filter.education': 'Onderwijs',
  'directory.filter.healthcare': 'Gezondheidszorg',
  'directory.filter.technology': 'Technologie',
  'directory.filter.business': 'Bedrijfsleven',
  'directory.filter.law': 'Recht',
  'directory.filter.engineering': 'Engineering',
  'directory.viewProfile': 'Bekijk Profiel',

  // Knowledge Hub
  'knowledge.title': 'Kennis- en Bronnencentrum',
  'knowledge.subtitle': 'Gidsen, Artikelen en Bronnen voor Uw Integratieproces',
  'knowledge.featured': 'Uitgelichte Publicaties',
  'knowledge.readMore': 'Lees Meer',
  'knowledge.viewAll': 'Bekijk Alle Publicaties',

  // Global Impact
  'impact.title': 'Onze Ondersteuningsprogramma\'s',
  'impact.subtitle': 'Wij Staan aan Uw Zijde in Elke Fase van Uw Integratiereis',
  'impact.education.title': 'Onderwijs- en Taalondersteuning',
  'impact.education.text': 'Nederlandse taalcursussen, onderwijsadvies en begeleiding bij diplomaerkenningsprocessen',
  'impact.healthcare.title': 'Gezondheids- en Sociale Ondersteuning',
  'impact.healthcare.text': 'Begeleiding in het gezondheidszorgsysteem, psychologische ondersteuning en sociale bijstandsprogramma\'s',
  'impact.research.title': 'Werk- en Carrièreondersteuning',
  'impact.research.text': 'Werk zoeken, CV-voorbereiding, beroepsopleiding en ondernemersadvies',
  'impact.humanitarian.title': 'Juridische en Administratieve Ondersteuning',
  'impact.humanitarian.text': 'Professionele begeleiding bij verblijfsvergunningen, staatsburgerschapsaanvragen en juridische processen',

  // Testimonials
  'testimonials.title': 'Van Onze Leden',
  'testimonials.subtitle': 'Stemmen uit Onze Gemeenschap',

  // Contact
  'contact.title': 'Neem Contact Op',
  'contact.subtitle': 'Heeft u vragen? We horen graag van u',
  'contact.name': 'Uw Naam',
  'contact.email': 'Uw E-mail',
  'contact.subject': 'Onderwerp',
  'contact.message': 'Uw Bericht',
  'contact.send': 'Verstuur Bericht',
  'contact.info.title': 'Contactinformatie',
  'contact.info.address': 'Adres',
  'contact.info.phone': 'Telefoon',
  'contact.info.email': 'E-mail',

  // Footer
  'footer.about.title': 'Over Stichting IPN',
  'footer.about.text': 'Een professioneel netwerk dat uitgebreide ondersteuning biedt aan alle mensen die naar Nederland komen tijdens hun integratieproces.',
  'footer.quickLinks': 'Snelle Links',
  'footer.connect': 'Blijf Verbonden',
  'footer.newsletter': 'Abonneer op Onze Nieuwsbrief',
  'footer.newsletter.placeholder': 'Voer uw e-mail in',
  'footer.newsletter.button': 'Abonneren',
  'footer.copyright': '© 2024 Stichting IPN. Alle rechten voorbehouden.',
  'footer.privacy': 'Privacybeleid',
  'footer.terms': 'Servicevoorwaarden',

  contact: {
    form: {
      name: 'Naam',
      namePlaceholder: 'Voer uw naam in',
      email: 'E-mail',
      emailPlaceholder: 'Voer uw e-mailadres in',
      phone: 'Telefoon',
      phonePlaceholder: 'Voer uw telefoonnummer in',
      subject: 'Onderwerp',
      subjectPlaceholder: 'Onderwerp van uw bericht',
      message: 'Bericht',
      messagePlaceholder: 'Schrijf hier uw bericht...',
      maxChars: 'Maximaal 500 tekens',
      submit: 'Bericht Verzenden',
      sending: 'Verzenden...',
      successMessage: 'Uw bericht is succesvol verzonden! We nemen zo snel mogelijk contact met u op.',
      errorMessage: 'Er is een fout opgetreden. Probeer het opnieuw.',
    },
    workingHours: 'Openingstijden',
    weekdays: 'Weekdagen',
    weekend: 'Weekend',
    closed: 'Gesloten',
  },
  news: {
    title: 'Vluchtelingen Nieuws Tracking Systeem',
    subtitle: 'Volg het laatste nieuws over vluchtelingen van IND, COA, gemeenten en media. Abonneer u op onze maandelijkse nieuwsbrief en mis geen belangrijke ontwikkelingen.',
    subscribe: 'Abonneer op Maandelijkse Nieuwsbrief',
    new: 'Nieuw',
    readMore: 'Lees Meer',
    categories: {
      all: 'Alles',
      municipality: 'Gemeenten',
      media: 'Media',
      policy: 'Beleid',
    },
    items: {
      ind1: {
        title: 'IND Kondigt Nieuwe Aanvraagprocedures Aan',
        summary: 'IND introduceert nieuwe procedures en snellere beoordelingsprocessen voor asielaanvragen. Belangrijke wijzigingen voor aanvragers.',
      },
      coa1: {
        title: 'COA Opent Nieuwe Opvangcentra',
        summary: 'COA heeft aangekondigd nieuwe opvangcentra te openen in heel Nederland om te reageren op de toegenomen vraag. Capaciteit stijgt met 30%.',
      },
      municipality1: {
        title: 'Amsterdam Breidt Integratieprogramma\'s Uit',
        source: 'Gemeente Amsterdam',
        summary: 'Gemeente Amsterdam verhoogt investeringen in taalcursussen en werkgelegenheidsprogramma\'s voor vluchtelingen. Nieuw budget goedgekeurd.',
      },
      media1: {
        title: 'Vluchtelingenintegratie in Nederland: Succesverhalen',
        summary: 'NOS heeft een speciale documentaire uitgebracht over succesvolle integratievoorbeelden en bijdragen van vluchtelingen aan de Nederlandse samenleving.',
      },
      policy1: {
        title: 'Nieuwe Integratiewet Goedgekeurd in Parlement',
        summary: 'Het Nederlandse parlement heeft een nieuwe wet goedgekeurd die het integratieproces voor vluchtelingen vergemakkelijkt en ondersteunt. Wet treedt in 2024 in werking.',
      },
      ind2: {
        title: 'IND Lanceert Digitaal Aanvraagsysteem',
        summary: 'IND heeft een nieuw platform geïntroduceerd waarmee asielaanvragen digitaal kunnen worden ingediend. Het proces is nu sneller en transparanter.',
      },
    },
    infoBox: {
      title: 'Automatische Nieuwstracking',
      description: 'Ons systeem scant dagelijks IND, COA, Overheid.nl, gemeenten en toonaangevende mediaorganisaties en verzamelt automatisch belangrijk nieuws over vluchtelingen. Abonneer u op onze maandelijkse nieuwsbrief om op de hoogte te blijven van alle belangrijke ontwikkelingen.',
    },
    modal: {
      title: 'Abonneer op Maandelijkse Nieuwsbrief',
      description: 'Voer uw e-mailadres in en ontvang elke maand het belangrijkste nieuws over vluchtelingen direct in uw inbox.',
      emailLabel: 'E-mailadres',
      emailPlaceholder: 'voorbeeld@email.com',
      subscribeButton: 'Abonneren',
      subscribing: 'Abonneren...',
      successMessage: 'U bent succesvol geabonneerd! U ontvangt binnenkort uw eerste nieuwsbrief.',
      errorMessage: 'Er is een fout opgetreden. Probeer het opnieuw.',
    },
  },

  integration: {
    title: 'Ons Integratieproces',
    subtitle: 'We staan bij elke stap naast je, van aankomst in Nederland tot het staatsburgerschap. Dit is het 6-stappen proces waar we je doorheen begeleiden.',
    step: 'Stap',
    requiredDocuments: 'Vereiste Documenten',
    tips: 'Belangrijke Tips',
    getSupport: 'Krijg Ondersteuning in Deze Fase',
    successTitle: 'Ontdek Succesverhalen',
    successDescription: 'Duizenden mensen hebben dit proces succesvol doorlopen. Laat je inspireren door hun ervaringen en word ook succesvol.',
    readStories: 'Lees Verhalen',
    
    steps: {
      step1: {
        shortTitle: 'Aankomst',
        title: 'Aankomst & Eerste Registratie',
        description: 'Eerste registratie in Ter Apel en tijdelijke huisvestingsregelingen',
        duration: '1-3 dagen',
        documents: [
          'Paspoort of identiteitsbewijs',
          'Reisdocumenten',
          'Onderwijs- en werkdocumenten indien beschikbaar',
          'Documenten die gezinssituatie aantonen'
        ],
        tips: [
          'Bewaar al je documenten op een veilige plek',
          'Wees eerlijk en open in het eerste gesprek',
          'Maak gebruik van tolkdiensten',
          'Luister goed naar de verstrekte informatie'
        ]
      },
      step2: {
        shortTitle: 'Interview',
        title: 'IND Interviews',
        description: 'Asielaanvraag en gedetailleerde gesprekken, je verhaal vertellen',
        duration: '6-12 maanden',
        documents: [
          'Identiteitsdocumenten en foto\'s',
          'Documenten ter ondersteuning van redenen om je land te verlaten',
          'Bewijs van bedreigingen of vervolging indien beschikbaar',
          'Documenten die familiebanden aantonen'
        ],
        tips: [
          'Vertel je verhaal consistent en gedetailleerd',
          'Beantwoord alle vragen zorgvuldig',
          'Krijg juridische ondersteuning',
          'Maak gebruik van psychologische ondersteuningsdiensten'
        ]
      },
      step3: {
        shortTitle: 'Vestiging',
        title: 'Verblijfsvergunning & Huisvesting',
        description: 'Verkrijgen van verblijfsvergunning en permanente huisvesting, begin van je nieuwe leven',
        duration: '2-6 maanden',
        documents: [
          'IND-besluit en verblijfsvergunning',
          'BSN (Burgerservicenummer) registratie',
          'Zorgverzekeringsbewijs',
          'Bankrekeninggegevens'
        ],
        tips: [
          'Schrijf je direct in bij de gemeente',
          'Sluit een zorgverzekering af (verplicht)',
          'Vraag sociale bijstand aan',
          'Maak kennis met je buurt en buren'
        ]
      },
      step4: {
        shortTitle: 'Onderwijs',
        title: 'Taal & Integratietraining',
        description: 'Nederlandse taalcursus en sociale integratieprogramma\'s, culturele aanpassing',
        duration: '6-36 maanden',
        documents: [
          'Inschrijvingsdocument inburgeringsexamen',
          'Certificaat deelname taalcursus',
          'Onderwijsvorderingenrapporten',
          'Examenresultaatdocumenten'
        ],
        tips: [
          'Woon cursussen regelmatig bij',
          'Oefen ook thuis Nederlands',
          'Neem deel aan lokale evenementen',
          'Solliciteer voor vrijwilligerswerk'
        ]
      },
      step5: {
        shortTitle: 'Werk',
        title: 'Werk Zoeken & Carrière',
        description: 'Beroepsopleiding, werkzoekondersteuning en carrièreplanningsdiensten',
        duration: '3-12 maanden',
        documents: [
          'CV en motivatiebrief',
          'Diplomaerkenningscertificaat',
          'Sollicitatiedocumenten',
          'Referentiebrieven'
        ],
        tips: [
          'Laat je diploma\'s erkennen',
          'Maak een Nederlands CV',
          'Breid je professionele netwerk uit',
          'Overweeg stage- en vrijwilligersmogelijkheden'
        ]
      },
      step6: {
        shortTitle: 'Staatsburgerschap',
        title: 'Staatsburgerschap & Daarna',
        description: 'Aanvraag Nederlands staatsburgerschap en volledige integratie in de samenleving',
        duration: '5+ jaar',
        documents: [
          '5-jarig verblijfsvergunningsdocument',
          'Succesbewijs inburgeringsexamen',
          'Inkomens- en belastingdocumenten',
          'Verklaring omtrent gedrag'
        ],
        tips: [
          'Voldoe aan alle wettelijke vereisten',
          'Toon actieve deelname aan de samenleving',
          'Kom je financiële verantwoordelijkheden na',
          'Omarm Nederlandse waarden'
        ]
      }
    }
  }
};

export default translation;